import React from 'react';
import PropTypes from 'prop-types';
import { OneContent, LinesAttention } from './WithLines.style';
import Placeholder from '../../../components/Placeholder';

class Lines extends React.Component {
  static propTypes = {
    linesData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currentLi: PropTypes.arrayOf(PropTypes.string).isRequired,
    clickLine: PropTypes.func.isRequired,
    isShowLines: PropTypes.bool.isRequired,
    copy: PropTypes.shape().isRequired,
  };

  render() {
    const { linesData, isShowLines, copy, clickLine, currentLi } = this.props;
    return (
      <React.Fragment>
        <OneContent isShowLines={isShowLines}>
          {linesData.length > 0 &&
            linesData.map(lineCategory =>
              (() => {
                if (lineCategory.lineFieldLabel !== undefined) {
                  let isFirst = true;
                  return lineCategory.lines.map(line => {
                    const productName = line.label === 'HAIR & SCALP CARE' ? line.key : line.label;
                    if (line.label && line.label !== '') {
                      return (
                        <div key={`${line.key}`}>
                          {(() => {
                            if (isFirst) {
                              isFirst = false;
                              return <h5>{lineCategory.lineFieldLabel}</h5>;
                            }
                            return null;
                          })()}
                          <li
                            role="presentation"
                            onClick={() => clickLine(lineCategory, line)}
                            onKeyDown={() => clickLine(lineCategory, line)}
                            style={{
                              color: currentLi.includes(line.key) ? '#000' : '#CCC',
                              borderColor: currentLi.includes(line.key) ? '#000' : '#CCC',
                            }}
                          >
                            {productName}
                          </li>
                        </div>
                      );
                    }
                    return null;
                  });
                }
                return '';
              })()
            )}
        </OneContent>
        <LinesAttention>{copy.select_line_help_text || <Placeholder w="100%" h="150px" />}</LinesAttention>
      </React.Fragment>
    );
  }
}

export default Lines;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/WithLines/Lines.js